<template>
    <div class="form-item">
        <div class="form-item__label">城市：</div>
        <div class="form-item__body">
            <div class="form-item__body_input wrapper" @click="select">
                <div class="form-item__body_input_text">{{info.city ? info.city: '请选择城市'}}</div>
                <img mode="aspectFit" class="form-item__body_icon" src="@/assets/icons/chevron-right-sharp-light.svg"/>
            </div>
        </div>
    </div>
</template>

<script>
    const weui = window.weui

    export default {
        props: ['info'],
        data () {
            return {
                cities: ['上海','北京','深圳','广州','杭州','南京','苏州','成都','武汉','重庆','天津','长沙','西安','合肥','宁波','郑州','佛山','青岛','东莞','厦门','昆明','福州']
            }
        },
        methods: {
            select () {
                const that = this
                weui.picker(this.cities, {
                    defaultValue: [this.info.city ? this.info.city : '上海'],
                    onConfirm: res => {
                        that.info.city = res[0].value
                    }
                })
            }
        }
    }
</script>
